export const setFlash = (state, payload) => state.flash = payload;